var _path, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNewSupplier = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.75V6.25C9.5 6.38807 9.38807 6.5 9.25 6.5H6.5V9.25C6.5 9.38807 6.38807 9.5 6.25 9.5H5.75C5.61193 9.5 5.5 9.38807 5.5 9.25V6.5H2.75C2.61193 6.5 2.5 6.38807 2.5 6.25V5.75C2.5 5.61193 2.61193 5.5 2.75 5.5H5.5V2.75C5.5 2.61193 5.61193 2.5 5.75 2.5H6.25C6.38807 2.5 6.5 2.61193 6.5 2.75V5.5H9.25C9.38807 5.5 9.5 5.61193 9.5 5.75Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipNewSupplier)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 19.9167C16.9424 19.9167 15.1667 18.141 15.1667 15.9583C15.1667 13.7757 16.9424 12 19.125 12C21.3076 12 23.0833 13.7757 23.0833 15.9583C23.0833 18.141 21.3076 19.9167 19.125 19.9167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7604 21.5C13.6863 21.5 12 23.1862 12 25.2604V28.0312C12 28.3558 12.2692 28.625 12.5938 28.625H19.9167V26.0521C19.9167 24.5637 21.025 23.3367 22.4579 23.1229C22.6638 22.5212 23.0517 22.0146 23.5504 21.6504C22.7588 21.424 22.716 21.5 15.7604 21.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4167 24.2708H28.2292V23.4792C28.2292 23.0419 27.8747 22.6875 27.4375 22.6875H25.0625C24.6253 22.6875 24.2708 23.0419 24.2708 23.4792V24.2708H23.0833C22.6461 24.2708 22.2917 24.6253 22.2917 25.0625V29.0208C22.2917 29.4581 22.6461 29.8125 23.0833 29.8125H29.4167C29.8539 29.8125 30.2083 29.4581 30.2083 29.0208V25.0625C30.2083 24.6253 29.8539 24.2708 29.4167 24.2708ZM27.0417 27.0417C27.0417 27.2603 26.8644 27.4375 26.6458 27.4375H25.8542C25.6355 27.4375 25.4583 27.2603 25.4583 27.0417V26.8437C25.4583 26.7344 25.5469 26.6458 25.6562 26.6458H26.8437C26.953 26.6458 27.0417 26.7344 27.0417 26.8437V27.0417ZM25.0625 24.2708H27.4375V23.4792H25.0625V24.2708Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipNewSupplier"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white",
    transform: "translate(12 12)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewSupplier, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NewSupplier.6a6a4742.svg";
export { ForwardRef as ReactComponent };